const LANGUAGE_FLAGS: Record<string, string> = {
    de: '🇩🇪',
    en: '🇺🇸',
    fr: '🇫🇷',
    es: '🇪🇸',
    it: '🇮🇹',
    pl: '🇵🇱',
    tr: '🇹🇷',
    ar: '🇸🇦',
    uk: '🇺🇦',
    ru: '🇷🇺',
  };
  
  export function getLanguageFlag(code: string): string {
    return LANGUAGE_FLAGS[code.toLowerCase()] ?? '🌐';
  }
  